<template>
  <a-card :bordered="true">
    <p v-if="!showPage">功能未开通</p>
    <!-- 表格内容操作 start -->
    <!-- <div class="table-operator">
      <a-button type="primary" style="margin-right:15px;">全部导出</a-button>
      <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button>
      <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"><a-icon type="file-zip" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div> -->
    <!-- 表格内容操作 end -->
    <a-tabs v-if="showPage" default-active-key="1">
      <a-tab-pane key="1" tab="待回稿">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit1">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker @change="onDateChange" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table1"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData1"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="status">
            待回稿
          </span>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm
              v-if="record.status==1"
              title="确认签收吗"
              @confirm="handleSignfor(record.sub_id)"
              okText="确认"
              cancelText="取消"
            >
              <a href="#">签收</a>
            </a-popconfirm>
            <a-divider v-if="record.status===2" type="vertical" />
            <a v-if="record.status===2" @click="showHgModal(record)">上传回稿</a>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="已完成">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit2">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table2"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData2"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <span slot="status">
            已完成
          </span>
          <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="showHgModal(record)">上传回稿</a>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="3" tab="已取消">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit3">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">刷新</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table3"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData3"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="class_demand" slot-scope="text, record">
            {{ record.student_data.requirement }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.student_data.qq }}
          </span>
          <span slot="status">
            已取消
          </span>
          <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="action">
            --
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
    </a-tabs>
    <a-modal :confirm-loading="confirmLoading" v-if="hgpathVisible" :visible="hgpathVisible" title="上传回稿" @ok="handleHgpathOk" @cancel="hgpathVisible = false">
      <a-upload
        name="file"
        :multiple="false"
        list-type="text"
        action="/teacher.php/upload_file/uploadFile?type=hgpath"
        @change="handleHgpathChange"
      >
        <a-button><a-icon type="upload" />点击上传回稿</a-button>
      </a-upload>
    </a-modal>
  </a-card>
</template>
<script>
import { getPre, getList, saveHgpath, saveSignfor } from '@/api/subscribe'
import { TcgTable } from '@/components'
import notification from 'ant-design-vue/es/notification'
import _ from 'lodash'
import { getUserInfo } from '@/api/account'

export default {
  components: {
    TcgTable
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam1: {
        ctype: '作文',
        status: 'UNHG',
        startTime: '',
        endTime: ''
      },
      queryParam2: {
        ctype: '作文',
        status: 'DONE'
      },
      queryParam3: {
        ctype: '作文',
        status: 'CANCEL'
      },
      // 表头
      columns: [
        {
          title: '日期',
          dataIndex: 'days'
        },
        {
          title: '旺旺名',
          dataIndex: 'uname'
        },
        {
          title: '课程名称',
          dataIndex: 'cname',
          scopedSlots: { customRender: 'cname' }
        },
        {
          title: '学生',
          dataIndex: 'student',
          scopedSlots: { customRender: 'student' }
        },
        {
          title: '联系方式',
          dataIndex: 'qq',
          scopedSlots: { customRender: 'qq' }
        },
        {
          title: '作文基础',
          dataIndex: 'zwjc',
          scopedSlots: { customRender: 'zwjc' }
        },
        {
          title: '作文目标',
          dataIndex: 'zwmb',
          scopedSlots: { customRender: 'zwmb' }
        },
        {
          title: '上传时间',
          dataIndex: 'zwtime'
        },
        {
          title: '回稿时间',
          dataIndex: 'hgtime'
        },
        {
          title: '上课要求',
          scopedSlots: { customRender: 'class_demand' },
          dataIndex: 'class_demand'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '原稿',
          dataIndex: 'zwpath',
          scopedSlots: { customRender: 'zwpath' }
        },
        {
          title: '回稿',
          dataIndex: 'hgpath',
          scopedSlots: { customRender: 'hgpath' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'sub_id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData1: parameter => {
        return getList(Object.assign(parameter, this.queryParam1))
          .then(res => {
            return res
          })
      },
      loadData2: parameter => {
        return getList(Object.assign(parameter, this.queryParam2))
          .then(res => {
            return res
          })
      },
      loadData3: parameter => {
        return getList(Object.assign(parameter, this.queryParam3))
          .then(res => {
            return res
          })
      },
      confirmLoading: false,
      hgpathVisible: false,
      hgpathData: {
        sub_id: 0,
        hgpath: ''
      },
      showPage: true
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      // 获取用户信息
      getUserInfo().then(response => {
        const classifcation = _.get(response, 'data.classifcation', [])
        console.log(classifcation)
        const fj= classifcation.findIndex(item => item=== '作文')
        if (fj === -1) {
          this.showPage = false
        }
      })
    },
    onDateChange(date, dateString) {
      console.log(dateString)
      this.queryParam1.startTime=dateString[0]
      this.queryParam1.endTime=dateString[1]
      this.$refs.table1.refresh(true)
    },
    showHgModal (record) {
      this.hgpathVisible = true
      this.hgpathData = {
        sub_id: record.sub_id,
        hgpath: ''
      }
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.hgpathData.hgpath = path
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleHgpathChange (info) {
      this.handleFileUpload(info, 'hgpath')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleHgpathOk () {
      if (this.hgpathData.hgpath === '') {
        this.$message.warning('请上传回稿')
        return false
      }
      this.confirmLoading = true
      saveHgpath(this.hgpathData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          this.$refs.table1.refresh(true)
          this.$refs.table2.refresh(true)
          this.hgpathVisible = false
          notification.success({
            message: '更新成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '更新失败',
            description: '请稍后再试'
          })
        }
      })
    },
    // 开启更多查询方式
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: ''
      }
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 提交筛选
    handleSubmit1 (e) {
      e.preventDefault()
      this.$refs.table1.refresh(true)
    },
    handleSubmit2 (e) {
      e.preventDefault()
      this.$refs.table2.refresh(true)
    },
    handleSubmit3 (e) {
      e.preventDefault()
      this.$refs.table3.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 表格选择
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 批量操作按钮事件
    handleMenuClick (e) {
      if (e.key === '1') {
        const arrImages = []
        for (const i in this.selectedRows) {
        }
      }
    },
    handleSignfor (subId) {
      saveSignfor({ sub_id: subId }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table1.refresh(true)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
